import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from 'reactstrap';
import { MiciMilestone, MiciPhase } from '../../../../services/types/MiciCases';
import { Button } from '../../../../shared/components';
import { customDateStr } from '../../../../shared/misc/utils';

interface MiciMilestoneRowData {
  milestone: MiciMilestone;
}

const MiciMilestoneRow = (props: MiciMilestoneRowData) => {
  const { milestone } = props;
  const { t } = useTranslation();
  return (
    <tr>
      <td style={{ width: '50%' }}>
        {t(`miciCaseMilestoneNames.${milestone.code}`, milestone.code)}
      </td>
      <td>{customDateStr(milestone.date)}</td>
    </tr>
  );
};

interface PhaseRow {
  phase: MiciPhase;
  currentPhase: string;
}

const MiciMilestoneListRow = (props: PhaseRow) => {
  const { phase, currentPhase } = props;
  const [rowExpanded, setRowExpanded] = useState(currentPhase === phase.code);
  const { t } = useTranslation();

  const chevron = rowExpanded ? 'chevron-down' : 'chevron-right';

  const renderMilestones = (milestones: MiciMilestone[]) =>
    milestones.map((x, i) => (
      <MiciMilestoneRow key={`milestoneRow${i.toString()}`} milestone={x} />
    ));

  return (
    <div className={`timeline-list-row py-3 ${rowExpanded ? 'active' : ''}`}>
      <Button
        className="btn-tertiary py-0 px-1"
        icon={chevron}
        text={t(`miciCaseStatusCodes.${phase.code}`, phase.code)}
        type="button"
        onClick={() => setRowExpanded((current) => !current)}
      />
      {rowExpanded && (
        <div className="table-wrapper">
          <Table responsive className="table--bordered">
            <thead>
              <tr>
                <th>{t('description')}</th>
                <th>{t('date')}</th>
              </tr>
            </thead>
            <tbody>{renderMilestones(phase.milestones)}</tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

interface Props {
  currentPhase: string;
  phases: MiciPhase[];
}

const MiciPhases: React.FC<Props> = (props) => {
  const { phases, currentPhase } = props;

  const renderPhases = () =>
    phases.map((x, i) => (
      <MiciMilestoneListRow key={`phaseRow${i.toString()}`} phase={x} currentPhase={currentPhase} />
    ));

  return <div className="mici-timeline-list timeline-list mt-2">{renderPhases()}</div>;
};

export default MiciPhases;
